/**
 * Phuket ↔ Krabi transfer prices of an airport transfer listing
 * (details.transport.route_prices.krabi), set by the provider: one price per
 * route tier, shared by Krabi Town and Ao Nang, both ways. Every field is
 * optional and starts empty (Ridalo never fills a price in); an empty field
 * means the routes of that tier are not offered. The server checks and
 * recomputes everything (backend/services/transfer_booking.py).
 */
export const KRABI_TIERS = ['airport', 'standard', 'rawai_nai_harn', 'cape_panwa'];
export const KRABI_ZONE_IDS = ['zone_krabi_town', 'zone_krabi_ao_nang'];
export const PHUKET_REGION = 'Phuket';

export const emptyKrabiPrices = () => Object.fromEntries(KRABI_TIERS.map((k) => [k, '']));

/** Form values from a saved listing (empty strings when not set). */
export const krabiPricesFrom = (transport) => {
  const saved = ((transport || {}).route_prices || {}).krabi || {};
  return Object.fromEntries(KRABI_TIERS.map((k) => [k, saved[k] != null && saved[k] !== '' ? String(saved[k]) : '']));
};

/** → { prices: { tier: number } (filled tiers only), invalid: [tier] }. */
export const krabiPricesPayload = (values) => {
  const prices = {};
  const invalid = [];
  KRABI_TIERS.forEach((k) => {
    const raw = String((values || {})[k] ?? '').trim();
    if (!raw) return;
    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) invalid.push(k);
    else prices[k] = n;
  });
  return { prices, invalid };
};

/** Zones a provider can serve from the airport (Phuket only: Krabi has its own field). */
export const airportZoneChoices = (zones, airportId) => (zones || [])
  .filter((z) => z.zone_id !== airportId && (z.region || PHUKET_REGION) === PHUKET_REGION);
